import {
  GetHistoryPathParamType,
  GetHistoryResponseBodyType,
} from "@intelligems/ig-types";
import { QueryMeta } from "@src/types/react-query";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { historyKeys } from "../queryKeys";
import { ApiRequest } from "../types/api";

export const getHistory = async (
  payload: ApiRequest<void, GetHistoryPathParamType>
) => {
  const resp = await api.get<GetHistoryResponseBodyType>(
    `/v2/experiences/${payload.pathParams.experienceId}/history`
  );
  return resp.data;
};
export const useGetHistory = (
  options: ApiRequest<void, GetHistoryPathParamType>,
  enabled = true
) => {
  return useQuery<GetHistoryResponseBodyType, Error>({
    queryKey: historyKeys.one(options.pathParams?.experienceId),
    queryFn: async () => getHistory(options),
    enabled: enabled && Boolean(options.pathParams?.experienceId),
    meta: {
      onError: {
        any: "ignore",
      },
    } as QueryMeta,
  });
};
